{
  "de": {
    "home": "Welt",
    "back": "Zurück",
    "pageTitleOverview": "Übersicht",
    "pageTitleList": "Listenansicht",
    "pageTitleElse": "Detailansicht",
    "currentlyActiveExhibitions": "aktiv",
    "selectExhibition": "Views",
    "exhibitions": "laufende Messen",
    "about": "Impressum",
    "copyright": "© 2019-2026 umati",
    "dataPolicy": "Datenschutzrichtlinien",
    "onlineOnly": "Machine ist online",
    "favorites": "Favoriten",
    "map": "Karte",
    "list": "Liste",
    "hall": "Halle",
    "booth": "Stand",
    "manufacturer": "Hersteller",
    "location": "Ort",
    "allHalls": "Alle",
    "filter": "Filter",
    "applyFilter": "Filter anwenden",
    "resetFilter": "Filter zurücksetzen",
    "search": "Suchen",
    "searchWithDots": "Suchen ...",
    "searchPlaceholder": "Nach Maschinen suchen...",
    "searchPlaceholderSoftware": "Nach software suchen...",
    "showStates": "Maschinenzustände anzeigen",
    "machineOverview": "Identifikation",
    "machineIsOffline": "Maschine ist offline",
    "machines": "Maschinen",
    "showMore": "Besuchen",
    "serialNumber": "Seriennummer",
    "buildYear": "Baujahr",
    "catalogName": "Katalog Name",
    "productCode": "Produkt Code",
    "software": "Software",
    "softwareVersion": "Software Version",
    "tools": "Werkzeuge",
    "jobs": "Aufträge",
    "monitoring": "Monitoring",
    "locked": "Gesperrt",
    "active": "Aktiv",
    "override": "Override",
    "overview": "Überblick",
    "isRotating": "Rotiert",
    "isNotRotating": "Steht",
    "uniqueId": "Benutzerdefinierte ID",
    "typeId": "Typen ID",
    "overallState": "Maschinenzustände",
    "subtitleTvViewMachineGrid": "In der letzten Stunde",
    "fairMapView": "Kartenansicht EMO Milano",
    "subtitleTvViewMapList": "Verbundene Maschine auf dem Messegelände",
    "online": "aktuell online",
    "noPosition": "Kein Ort hinterlegt",
    "runs": "Läufe",
    "initialized": "Initialisieren",
    "notInitialized": "Nicht Initialisiert",
    "jobIdentifier": "Job Identifier",
    "activeProgram": "Aktives Programm",
    "pleaseNote": "",
    "noMachinesToShow": "",
    "magazineName": "Stellplatzname",
    "magazinePlaceNumber": "Stellplatznummer",
    "name": "Name",
    "jobNodeId": "Job Node Id",
    "programStateId": "Zustands-ID",
    "programStateNumber": "Zustandsnummer",
    "programStateName": "Zustand",
    "channelMode": "Kanalmodus",
    "channelState": "Kanalzustand",
    "isOn": "Aktiv",
    "isOff": "Inaktiv",
    "laserState": "Laserzustand",
    "edmGeneratorState": "Funkenerodiererzustand",
    "isUsedAsAxis": "Als Achse genutzt",
    "isNotUsedAsAxis": "Nicht als Achse genutzt",
    "state": "Zustand",
    "minOverride": "Minimaler Override",
    "maxOverride": "Maximaler Override",
    "statusOverview": "Zustandsübersicht",
    "machineTool": "Werkzeugmaschine",
    "operationMode": "Arbeitsmodus",
    "powerOnDuration": "Einschaltdauer",
    "isWarmUp": "Maschine in Warmup Phase?",
    "softwareDemoPage": "Demo Page",
    "details": "Details",
    "information": "Informationen",
    "homepage": "Webpräsenz",
    "demopage": "Demo-Seite",
    "markAsFavorite": "Als Favorit setzen",
    "connectionInfo": "Verbindungsstatus",
    "specification": "Spezifikation",
    "productUri": "ProduktUri",
    "volume": "Volumen",
    "actualValue": "Aktueller Wert",
    "setPoint": "Sollwert",
    "operationalHours": "Betriebsstunden",
    "operationalState": "Betriebszustand",
    "powerOnHours": "Stunden eingeschaltet",
    "deviceClass": "Device Class",
    "model": "Modell",
    "currentMode": "Maschinenmodus",
    "currentState": "Maschinenzustand",
    "AxisOverride": "Override Achse",
    "powerPresent": "Leistung verfügbar",
    "airPresent": "Luft vorhanden",
    "calibrated": "Kalibriert",
    "workpiecePresent": "Werkstück vorhanden",
    "emergency": "Notfall",
    "alarm": "Alarm",
    "FeedSpeed": "Vorschubgeschwindigkeit",
    "jobManagement": "Auftragsverwaltung"
  },
  "en": {
    "statusOverview": "Status Overview",
    "home": "Home",
    "back": "Back",
    "pageTitleOverview": "Overview",
    "pageTitleList": "List View",
    "pageTitleElse": "Detail View",
    "currentlyActiveExhibitions": "active exhibitions",
    "selectExhibition": "Views",
    "exhibitions": "Exhibitions",
    "about": "Imprint",
    "copyright": "© 2019-2026 umati",
    "dataPolicy": "Privacy Policy",
    "onlineOnly": "Machine is online",
    "favorites": "Favorites",
    "map": "Map",
    "list": "List",
    "hall": "Hall",
    "booth": "Booth",
    "manufacturer": "Manufacturer",
    "location": "Location",
    "allHalls": "All",
    "filter": "Filter",
    "applyFilter": "Apply Filter",
    "resetFilter": "Reset Filter",
    "search": "Search",
    "searchWithDots": "Search for ...",
    "searchPlaceholder": "Search for machines...",
    "searchPlaceholderSoftware": "Search for software...",
    "showStates": "Show states",
    "machineOverview": "Identification",
    "machineIsOffline": "Machine is offline",
    "machines": "Machines",
    "showMore": "Show more",
    "serialNumber": "Serial Number",
    "buildYear": "Build Year",
    "catalogName": "Catalog Name",
    "productCode": "Product Code",
    "software": "Software",
    "softwareVersion": "Software Version",
    "tools": "Tools",
    "jobs": "Jobs",
    "monitoring": "Monitoring",
    "magazineName": "Location Name",
    "magazinePlaceNumber": "Location Number",
    "jobIdentifier": "Job Identifier",
    "activeProgram": "Active Program",
    "locked": "Locked",
    "active": "Active",
    "override": "Override",
    "overview": "Overview",
    "isRotating": "Rotating",
    "isNotRotating": "Stopped",
    "uniqueId": "Unique Id",
    "typeId": "Type id",
    "overallState": "Overall Status of connected machines",
    "subtitleTvViewMachineGrid": "In the last hour",
    "fairMapView": "Map View",
    "subtitleTvViewMapList": "Connected machines on the fairground",
    "online": "currently online",
    "noPosition": "No Location defined",
    "runs": "Runs",
    "initialized": "Initializing",
    "notInitialized": "Not Initialized",
    "pleaseNote": "Please Note:",
    "noMachinesToShow": "No machines to show. Either there are no machines or your filter settings are to strict",
    "name": "Name",
    "jobNodeId": "Job Node Id",
    "programStateId": "State Id",
    "programStateNumber": "State Number",
    "programStateName": "State Name",
    "channelMode": "Channel Mode",
    "channelState": "Channel State",
    "isOn": "Active",
    "isOff": "Inactive",
    "laserState": "Laser State",
    "edmGeneratorState": "EDM Generator State",
    "isUsedAsAxis": "Is used as an axis",
    "isNotUsedAsAxis": "Is not used as an axis",
    "state": "State",
    "minOverride": "Minimal Override",
    "maxOverride": "Maximum Override",
    "machineTool": "Machine Tool",
    "operationMode": "Operation Mode",
    "powerOnDuration": "Power On Duration",
    "isWarmUp": "Is warming up?",
    "softwareWebpage": "Demo Page",
    "details": "Details",
    "information": "Information",
    "homepage": "Homepage",
    "demopage": "Demo Page",
    "markAsFavorite": "Mark as favorite",
    "connectionInfo": "Connection state",
    "specification": "Specification",
    "productUri": "ProductUri",
    "volume": "Volume",
    "actualValue": "Actual value",
    "setPoint": "SetPoint",
    "operationalHours": "Operational hours",
    "operationalState": "Operational state",
    "powerOnHours": "Power on hours",
    "deviceClass": "Device Class",
    "model": "Model",
    "currentMode": "Machine Mode",
    "currentState": "Machine State",
    "AxisOverride": "Axis Override",
    "powerPresent": "Power present",
    "airPresent": "Air present",
    "calibrated": "Calibrated",
    "workpiecePresent": "Pieces in",
    "emergency": "Emergency",
    "alarm": "Alarm",
    "FeedSpeed": "Feed Speed",
    "jobManagement": "Job Management"
  }
}
